<template>
  <section>
    <TopNavbar />
    <div class="wrapper">
      <AddCandidateBtnModal />
    </div>
  </section>
</template>

<script>
import TopNavbar from '../../Navigations/TopNavbar';
import AddCandidateBtnModal from './AddCandidateBtnModal';

export default {
  components: {
    TopNavbar,
    AddCandidateBtnModal,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 80px 30px 0 30px;
}
</style>
